import React from 'react';

const Button = ({label, onClick, type = 'button', submit = false, className = '', disabled = false}) => {
    let _className = `group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${className}`;

    // disabled class
    if (disabled) {
        _className += ` disabled`;
    }


    return (
        <button
        type={submit ? 'submit' : type}
        disabled={disabled}
        onClick={() => !disabled && onClick?.()}
        className={_className}>
        {label}
    </button>
);
};

export default Button;
